import { AxiosError } from "axios";
import type { BaseQueryFn } from "@reduxjs/toolkit/query";
import type { AxiosLoginBaseQueryConfig } from "./typesLogin";
import type { BaseQueryError } from "@shared/types/baseQueryError";
import { AxiosSingletonInstance } from "../AxiosSingletonInstances";
import { getCookie } from "typescript-cookie";
import { appEnv } from "../appEnv";

// import.meta.env.VITE_CONFIGURATOR_BASEURL ?? 
// const axiosInstance =  
// axios.create({
//     baseURL: BASE_URL,
//     withCredentials: true
// });

const axiosLoginBaseQuery = (
    baseURL: string,
): BaseQueryFn<AxiosLoginBaseQueryConfig, unknown, BaseQueryError> => {
    const axiosInstance = AxiosSingletonInstance.getInstance({
        refreshTokenUrl: `${appEnv.CONFIGURADOR_BASEURL}/auth/refresh`,
        cookieName: appEnv.COOKIE_NAME
    });
    return async ({ url, data, method, params }) => {
        try {
            const result = await axiosInstance({
                url: `${baseURL}${url}`,
                data,
                method,
                params,
                headers: { Authorization: `Bearer ${getCookie(appEnv.COOKIE_NAME)}` },
            });
            return { data: result.data };
        } catch (error) {
            const axiosError = error as AxiosError<BaseQueryError>;
            const baseError: BaseQueryError = {
                message: axiosError.response?.data?.message || axiosError.message || 'Unkown error occurred',
                status: axiosError.response?.status || 500,
                name: axiosError.name || 'AxiosError',
            };
            return {
                error: baseError,
            };
        }
    }
}

// const axiosLoginBaseQuery = (): BaseQueryFn<
//     AxiosLoginBaseQueryConfig,
//     unknown,
//     unknown
// > => async({ url, data, method, params }) => {
//     try {
//         const result = await axiosInstance({ url, data, method, params })
//         return {data: result.data}
//     } catch (error) {
//         return {
//             error: {
//                 status: (error as AxiosError)?.response?.status,
//                 data: (error as AxiosError)?.response?.data || (error as AxiosError).message
//             }
//         }
//     }
// }



export default axiosLoginBaseQuery;